<template>
  <div>
    <div class="custom-tree-container">
      <el-button v-if="addAuth" type="primary" @click="$refs.editPage.open(null, null, null, null, null,parentList, 1)">新建一级</el-button>
      <div style="margin: 20px 40px 20px 0px;">
        <el-tree
            :data="data"
            :props="defaultProps"
            node-key="id"
            default-expand-all
            :expand-on-click-node="false">
          <span slot-scope="{ node, data }" class="custom-tree-node">
            <span>{{node.label}}</span>
            <span>
              <el-button
                  type="text"
                  style="margin-left: 40px;"
                  icon="el-icon-circle-plus"
                  @click="append(data)"/>
              <el-button
                  type="text"
                  style="margin-left: 10px;"
                  icon="el-icon-edit"
                  @click="edit(node, data)"/>
              <el-button
                  type="text"
                  style="margin-left: 10px;"
                  icon="el-icon-delete"
                  @click="remove(data)"/>
            </span>
          </span>
        </el-tree>
      </div>
    </div>
    <product-category-edit ref="editPage" @save-success="getData()"/>
  </div>
</template>
<script>
  import ProductCategoryEdit from "@/views/information/ProductCategory/ProductCategoryEdit.vue";

  export default {
    name:"ProductCategory",
    components: {ProductCategoryEdit},
    data() {
      return {
        addAuth: this.$auth(623),
        editAuth: this.$auth(625),
        deleteAuth: this.$auth(624),
        data: [],
        parentList: [],
        defaultProps: {
          children: "children",
          label: "name",
        },
      };
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        this.$http
          .get("basic","productCategories").then((res) => {
            if (res) {
              console.log(res);
              if (res) {
                this.parentList = res[0].showIndexList;
              }
              this.data = JSON.parse(JSON.stringify(res));
            } else {
              this.$message.error("获取数据出错");
            }
          });
      },
      append(data) {
        let list=[];
        console.log(data.children);
        if (data.children.length>0) {
          list = data.children[0].showIndexList;
        }
        this.$refs.editPage.open(data.id, null, null,null,null,list, 0);
      },
      edit(node, data) {
        this.$refs.editPage.open(node.parent.data.id, data.id, data.name, data.templateID,data.templateName,data.showIndexList,0);
      },
      remove(data) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.delete("basic","productCategories", data.id).then(() => {
            this.getData();
            this.$message.success("删除成功");
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .custom-tree-node {
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
</style>
